import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  BRANCH_LIST,
  BRANCH_CREATE,
  BRANCH_UPDATE,
  BRANCH_DETAILS,
  BRANCH_DELETE,
  BRANCH_MEMBERS,
  ADD_EMPLOYEES_TO_BRANCH,
  REMOVE_MEMBER_FROM_BRANCH,
  BULK_UPLOAD_BRANCH_MEMBERS,
} from '../constants/action-types'

import { ThunkAction } from 'redux-thunk'
import { Action, Store } from 'redux'
import {
  INSTITUTE_URL,
  ADD_EMPLOYEES_TO_BRANCH_URL,
  BRANCH_MEMBERS_LIST_URL,
  REMOVE_MEMBER_FROM_BRANCH_URL,
  BULK_UPLOAD_BRANCH_MEMBERS_URL,
} from '../../service/apiEndPoints'
import { showErrorToastMessage } from '../../util/utils'

// ************** Branch List ******************

export const branchList =
  (
    id: number,
    search?: string,
    ordering?: string,
    page?: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_LIST.BRANCH_LIST_INITIALIZATION,
    })
    apiCall(
      INSTITUTE_URL,
      (res: any) => {
        dispatch({
          type: BRANCH_LIST.BRANCH_LIST_SUCCESS,
          payload: res.data,
        })
      },
      (err: any) => {
        dispatch({
          type: BRANCH_LIST.BRANCH_LIST_ERROR,
        })
        showErrorToastMessage(
          err?.data?.email?.[0] || err?.message || 'Something went wrong'
        )
      },
      {
        params: {
          id,
          ordering,
          search: search || undefined,
          page: page || undefined,
        },
      },
      METHOD.GET,
      { showToast: false }
    )
  }

// ************** CREATE BRANCH ******************

export const branchCreate =
  (
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(branchCreateInit(payload, _handleRedirect, _handleFailure))
  }

export const branchCreateInit =
  (
    payload,
    _handleRedirect,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_CREATE.BRANCH_CREATE_INITIALIZATION,
    })
    apiCall(
      INSTITUTE_URL,
      (res: any) =>
        dispatch(branchCreateSuccess(res, payload, _handleRedirect)),
      (err: any) => {
        dispatch(branchCreateError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: false }
    )
  }

export const branchCreateSuccess =
  (
    res: any,
    payload,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_CREATE.BRANCH_CREATE_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const branchCreateError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    let message = ''
    if (err?.data?.contact_number) {
      message += err?.data?.contact_number.toString() + '\n'
    }
    if (err?.data?.email) {
      message += err?.data?.email.toString() + '\n'
    }
    if (!(err?.data?.contact_number || err?.data?.email)) {
      message += err?.message
    }
    showErrorToastMessage(message)
  }

// ************** UPDATE branch ******************

export const branchUpdate =
  (
    showToast = false,
    branchId: number,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      branchUpdateInit(
        showToast,
        branchId,
        payload,
        _handleRedirect,
        _handleFailure
      )
    )
  }

export const branchUpdateInit =
  (
    showToast: boolean,
    branchId: number,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_UPDATE.BRANCH_UPDATE_INITIALIZATION,
    })
    apiCall(
      INSTITUTE_URL + '/' + branchId,
      (res: any) => dispatch(branchUpdateSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(branchUpdateError(err, _handleFailure))
      },
      payload,
      METHOD.PUT,
      { showToast: showToast }
    )
  }

export const branchUpdateSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_UPDATE.BRANCH_UPDATE_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const branchUpdateError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_UPDATE.BRANCH_UPDATE_ERROR,
      payload: err.message,
    })
    _handleFailure()
  }
// ************** BRANCH_DETAILS ******************

export const branchDetails =
  (
    showToast: boolean,
    ID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(branchDetailsInit(showToast, ID))
  }

export const branchDetailsInit =
  (
    showToast: boolean,
    ID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_DETAILS.BRANCH_DETAILS_INITIALIZATION,
    })
    apiCall(
      INSTITUTE_URL + `/${ID}`,
      (res: any) => dispatch(branchDetailsSuccess(res)),
      (err: any) => {
        dispatch(branchDetailsError(err))
      },
      {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const branchDetailsSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_DETAILS.BRANCH_DETAILS_SUCCESS,
      payload: res,
    })
  }

export const branchDetailsError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_DETAILS.BRANCH_DETAILS_ERROR,
      payload: err.message,
    })
  }
// ************** BRANCH_DELETE ******************

export const branchDeactivate =
  (
    ID: any,
    _handleRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(branchDeactivateInit(ID, _handleRedirect))
  }

export const branchDeactivateInit =
  (
    ID: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_DELETE.BRANCH_DELETE_INITIALIZATION,
    })
    apiCall(
      INSTITUTE_URL + `/${ID}`,
      (res: any) => dispatch(branchDeactivateSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(branchDeactivateError(err))
      },
      {},
      METHOD.DELETE,
      { showToast: true }
    )
  }

export const branchDeactivateSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_DELETE.BRANCH_DELETE_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const branchDeactivateError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_DELETE.BRANCH_DELETE_ERROR,
      payload: err.message,
    })
  }

// ************** ADD CANDIDATES TO branch  ******************

export const addEmployeesToBranch =
  (
    ID: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      addEmployeesToBranchInit(ID, payload, _handleRedirect, _handleFailure)
    )
  }

export const addEmployeesToBranchInit =
  (
    ID: any,
    payload: object,
    _handleRedirect,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ADD_EMPLOYEES_TO_BRANCH.ADD_EMPLOYEES_TO_BRANCH_INITIALIZATION,
    })
    apiCall(
      ADD_EMPLOYEES_TO_BRANCH_URL.replace('<institute_id>', ID),
      (res: any) => dispatch(addEmployeesToBranchSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(addEmployeesToBranchError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: true }
    )
  }

export const addEmployeesToBranchSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ADD_EMPLOYEES_TO_BRANCH.ADD_EMPLOYEES_TO_BRANCH_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const addEmployeesToBranchError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    showErrorToastMessage(
      err?.data?.employees ? err.data.employees.toString() : err?.message
    )
  }

// ************** BRANCH MEMBERS LIST ******************
export const branchMembersListData =
  (
    batchID: any,
    pageNo?: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(branchMembersListDataInit(batchID, pageNo))
  }

export const branchMembersListDataInit =
  (batchID, pageNo): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_MEMBERS.BRANCH_MEMBERS_INITIALIZATION,
    })
    apiCall(
      BRANCH_MEMBERS_LIST_URL.replace('<institute_id>', batchID),
      (res: any) => dispatch(branchMembersListDataSuccess(res)),
      (err: any) => {
        dispatch(branchMembersListDataError(err))
      },
      { params: { page: pageNo } },
      METHOD.GET,
      { showToast: false }
    )
  }

export const branchMembersListDataSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_MEMBERS.BRANCH_MEMBERS_SUCCESS,
      payload: res,
    })
  }

export const branchMembersListDataError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BRANCH_MEMBERS.BRANCH_MEMBERS_ERROR,
      payload: err.message,
    })
  }

// ************** REMOVE MEMBER FROM BRANCH ******************
export const removeMemberFromBranch =
  (
    ID: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      removeMemberFromBranchInit(ID, payload, _handleRedirect, _handleFailure)
    )
  }

export const removeMemberFromBranchInit =
  (
    ID,
    payload,
    _handleRedirect,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ADD_EMPLOYEES_TO_BRANCH.ADD_EMPLOYEES_TO_BRANCH_INITIALIZATION,
    })
    apiCall(
      REMOVE_MEMBER_FROM_BRANCH_URL.replace('<institute_id>', ID),
      (res: any) =>
        dispatch(removeMemberFromBranchSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(removeMemberFromBranchError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: true }
    )
  }

export const removeMemberFromBranchSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: REMOVE_MEMBER_FROM_BRANCH.REMOVE_MEMBER_FROM_BRANCH_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const removeMemberFromBranchError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: REMOVE_MEMBER_FROM_BRANCH.REMOVE_MEMBER_FROM_BRANCH_ERROR,
      payload: err.message,
    })
    _handleFailure()
  }

// ************** BULK UPLOAD MEMBERS TO BRANCH ******************
export const bulkUploadMembersToBranch =
  (
    ID: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      bulkUploadMembersToBranchInit(
        ID,
        payload,
        _handleRedirect,
        _handleFailure
      )
    )
  }

export const bulkUploadMembersToBranchInit =
  (
    ID,
    payload,
    _handleRedirect,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ADD_EMPLOYEES_TO_BRANCH.ADD_EMPLOYEES_TO_BRANCH_INITIALIZATION,
    })
    apiCall(
      BULK_UPLOAD_BRANCH_MEMBERS_URL,
      (res: any) =>
        dispatch(bulkUploadMembersToBranchSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(bulkUploadMembersToBranchError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: true }
    )
  }

export const bulkUploadMembersToBranchSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BULK_UPLOAD_BRANCH_MEMBERS.BULK_UPLOAD_BRANCH_MEMBERS_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const bulkUploadMembersToBranchError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BULK_UPLOAD_BRANCH_MEMBERS.BULK_UPLOAD_BRANCH_MEMBERS_ERROR,
      payload: err.message,
    })
    _handleFailure()
  }
